import {peakAlert} from "../../../../PeakDialog.js";
import jQuery from "jquery";
import {LandingPage} from "./LandingPage.js";
import {ImageTextColumnLandingPageWidget} from "./widgets/ImageTextColumnLandingPageWidget.js";
import {ImageTextColumn} from "./widgets/util/ImageTextColumn.js";
import {VideoLandingPageWidget} from "./widgets/VideoLandingPageWidget.js";
import {LandingPageRow} from "./LandingPageRow.js";
import {LandingPageWidget} from "./LandingPageWidget.js";
import { ZIDXFormConfig } from "../../../../form/FormConfig.js";
import {ZIDXFormHelper} from "../../../../form/FormHelper.js";
import {ZIDX} from "../../../../standalone/standaloneLibrary.js";
import {PageBuilderOptions} from "./LandingPageEditorOptions.js";

const $ = jQuery.noConflict();
export class WidgetTypeLookup{
    [key:string]:string;
}
export class WidgetTypeClassNameLookup{
    [key:string]:string;
}
export class WidgetType{
    public label:string;
    public value:string;
    constructor(label:string, value:string) {
        this.label=label;
        this.value=value;
    }
}
export class LandingPageEditor{
    options:PageBuilderOptions;
    container:HTMLDivElement;
    formsContainer:HTMLDivElement;
    debugContainer:HTMLDivElement;
    jsonField:HTMLInputElement;
    typeLookup:WidgetTypeLookup=new WidgetTypeLookup();
    landingPage:LandingPage=new LandingPage();
    currentLandingPageRow:LandingPageRow=new LandingPageRow();
    currentRowIndex:number=0;
    widgetTypes:WidgetType[]=[];
    formElement:HTMLFormElement|null=null;
    lastDialogFormData:any={};
    zidx:ZIDX;
    constructor(options:PageBuilderOptions, zidx:ZIDX) {
        this.options=options;
        this.zidx = zidx;
        this.container=<HTMLDivElement>this.zidx.peakidxShadowRoot.getElementById(options.containerId)!;
        this.formsContainer=<HTMLDivElement>this.zidx.peakidxShadowRoot.getElementById(options.formsContainerId)!;
        this.debugContainer=<HTMLDivElement>this.zidx.peakidxShadowRoot.getElementById(options.debugContainerId)!;
        this.jsonField=(<HTMLInputElement>this.zidx.peakidxShadowRoot.getElementById("landing_page_json")!);
    }
    loadDebugData(){
        // not used anymore
        let landingPage=new LandingPage();
        for(let n=1;n<=3;n++) {
            let row = new LandingPageRow();
            row.name = "Row " + n;
            let widget = new ImageTextColumnLandingPageWidget();
            row.heading = "Heading" + n;
            row.marginBottomPercent = 6;
            row.marginTopPercent = 6;
            widget.centerText = false;
            widget.columns = [];
            for (let i = 1; i <= 2; i++) {
                let column = new ImageTextColumn();
                column.heading1 = "Heading " + i;
                column.image = "/static/images/test4k.jpg";
                widget.columns.push(column);
            }
            row.widgetType = widget.getClassName();
            row.widgets.push(widget);
            landingPage.rows.push(row);
        }
        this.jsonField.value=JSON.stringify(landingPage);
    }
    loadLookupTable(){
        let typeClassNameLookup:WidgetTypeClassNameLookup={};
        let arrWidget=[
            new ImageTextColumnLandingPageWidget(),
            new VideoLandingPageWidget()
        ];
        for(let i=0;i<arrWidget.length;i++){
            let widget=arrWidget[i];
            this.typeLookup[widget.getClassName()]=widget.getName();
            typeClassNameLookup[widget.getName()]=widget.getClassName();
        }
        let arrSort=[];
        for(let className in this.typeLookup){
            arrSort.push(this.typeLookup[className]);
        }
        arrSort.sort();
        for(let i=0;i<arrSort.length;i++){
            let s=arrSort[i];
            let widgetType=new WidgetType(s, typeClassNameLookup[s]);
            this.widgetTypes.push(widgetType);
        }
    }
    getWidgetName(widgetClassName:string){
        return this.typeLookup[widgetClassName];
    }
    loadFailed:boolean=false;
    loadJSON(jsonString:string):LandingPage{
        let landingPage = new LandingPage();
        this.loadFailed=false;
        try {
            if(jsonString.trim()==""){ return landingPage; }
            let json = JSON.parse(jsonString);
            if (typeof json.rows != "undefined") {
                for (let i = 0; i < json.rows.length; i++) {
                    let row = json.rows[i];
                    let landingPageRow = new LandingPageRow();
                    for (let i in row) {
                        if (i == "widgets") {
                            for (let n = 0; n < row.widgets.length; n++) {
                                let widgetData = row.widgets[n];
                                let widget: LandingPageWidget;
                                switch (row.widgetType) {
                                    case "image-and-text-column":
                                        widget = new ImageTextColumnLandingPageWidget();
                                        break;
                                    default:
                                        throw("Invalid widget type:" + row.widgetType);
                                }
                                widget.loadData(widgetData);
                                landingPageRow.widgets.push(widget);
                            }
                        } else if (landingPageRow.hasOwnProperty(i)) {
                            landingPageRow[i] = row[i];
                        }
                    }
                    landingPage.rows.push(landingPageRow);
                }
            }
        }catch(e){
            // keep the original JSON in the hidden field so a failed load never overwrites saved content
            this.loadFailed=true;
            console.error("Landing page JSON could not be fully loaded; original data preserved", e);
        }
        return landingPage;
    }
    render(){
        let self=this;
        // this.loadDebugData();
        this.loadLookupTable();
        this.landingPage=this.loadJSON(this.jsonField.value);
        // console.log(this.landingPage);
        let a:string[]=[];
        a.push('<table id="sortTableID" class="zidxTableList zidxRecordSort">');
        a.push('<thead><tr><th>Name</th><th>Heading</th><th>Type</th><th>Admin</th></tr></thead><tbody>');
        for(let i=0;i<this.landingPage.rows.length;i++){
            let row=this.landingPage.rows[i];
            a.push('<tr id="'+i+'">'+row.renderRowHTML(this)+'</tr>');
        }
        a.push('</tbody></table>');
        a.push('<p><a href="#" class="landingPageCreateRowLink zidxManagerSearchButton">Create Row</a></p>');

        this.container.innerHTML=a.join("\n");
        this.updateData();
        this.setupSortable();
        $("#landing_page_name", this.zidx.peakidxShadowRoot).on("input paste change", function(e:any){
            self.updateData();
        });
        self.formsContainer.innerHTML='<div id="landingPageRowDialog" title="Row" ></div>';
        let dialogContainer=(<HTMLDivElement>this.zidx.peakidxShadowRoot.getElementById("landingPageRowDialog")!);
        peakAlert("jquery ui dialog was removed to make the website a module, so this will not work. Need to reimplement this section to work in future.");
        // let formDialog = $(dialogContainer).dialog({
        //     autoOpen: false,
        //     width: "auto",
        //     height: "auto",
        //     resizable:false,
        //     draggable:false,
        //     modal: true,
        //     open: function( event:any, ui:any ) {
        //         $("body").css({ overflow: 'hidden' })
        //         // console.log("dialog create fired");
        //         if(self.currentRowIndex==-1) {
        //             self.currentLandingPageRow=new LandingPageRow();
        //         }else{
        //             self.currentLandingPageRow=self.landingPage.rows[self.currentRowIndex];
        //         }
        //         let formConfig=new ZIDXFormConfig();
        //         formConfig.action="/account/landing-pages/fake";
        //         formConfig.cancelURL="";
        //         formConfig.disableButtons=true;
        //         formConfig.formFields=[];
        //         self.currentLandingPageRow.getFormConfig(self, formConfig);
        //         let formHelper=new ZIDXFormHelper(self.zidx);
        //         let extraData={
        //             rowIndex:self.currentRowIndex
        //         };
        //         dialogContainer.innerHTML=formHelper.getForm(formConfig, self.currentLandingPageRow, extraData);
        //         self.formElement=<HTMLFormElement>this.zidx.peakidxShadowRoot.getElementById(formHelper.formId)!;
        //         self.lastDialogFormData=self.zidx.getFormDataByFormId(self.formElement.id);
        //         formHelper.setupEvents();
        //         location.hash = "zidxDialogOpen";
        //     },
        //     buttons: {
        //         "Save": function () {
        //             self.saveDialog(formDialog);
        //         },
        //         Cancel: function () {
        //             formDialog.dialog("close");
        //         }
        //     },
        //     beforeClose: function(event:any, ui:any) {
        //         let rs=self.hasFormDataChanged(self.formElement!, self.lastDialogFormData);
        //         if(rs.changed){
        //             if(confirm("Are you sure you want to go back? Changes you made may not be saved.")) {
        //                 self.lastDialogFormData=rs.data;
        //             }else{
        //                 return false;
        //             }
        //         }
        //         if(location.hash != null && location.hash == "#zidxDialogOpen"){
        //             history.back();
        //             return false;
        //         }
        //         return true;
        //     },
        //     close: function () {
        //         $("body").css({ overflow: 'inherit' });
        //         // formElement.reset();
        //         //allFields.removeClass( "ui-state-error" );
        //     }
        // });
        // $(window).bind('hashchange', function () {
        //     if (location.hash == null || location.hash == "") {
        //         formDialog.dialog("close");
        //     }
        // });
        //
        // function resizeDialog(){
        //     if($(window).width()!<992) {
        //         $("#landingPageRowDialog").dialog({
        //             width: $(window).width()! - 20,
        //             height: $(window).height()!-20
        //         });
        //         $("#landingPageRowDialog").dialog( "option", "position", { my: "center", at: "center", of: window } );
        //     }else{
        //         $("#landingPageRowDialog").dialog({
        //             width: $(window).width()!-50,
        //             height: $(window).height()!-50,
        //         });
        //         $("#landingPageRowDialog").dialog( "option", "position", { my: "center", at: "center", of: window } );
        //     }
        // }
        // $(window).on("clientresize resize", function() {
        //     resizeDialog();
        // });
        // resizeDialog();
        // setTimeout(function(){
        //     resizeDialog();
        // },100);

        // $(".zidxPageActive .landingPageCreateRowLink").on("click", function(this, e:JQuery.ClickEvent) {
        //     e.preventDefault();
        //     // console.log("open dialog");
        //     self.currentRowIndex=-1;
        //     formDialog.dialog("open");
        // });
        // $(this.zidx.peakidxShadowRoot).off("click", ".zidxPageActive .zidxScriptSort").on("click", ".zidxPageActive .zidxScriptSort", function(this:HTMLAnchorElement, e:JQuery.ClickEvent){
        //     e.preventDefault();
        //     // let tr=self.getParentElementByType(this, "tr");
        //     // let id=$(tr).attr("id");
        //     // console.log("click sort:"+id);
        // });
        // $(this.zidx.peakidxShadowRoot).off("click", ".zidxPageActive .zidxScriptEdit").on("click", ".zidxPageActive .zidxScriptEdit", function(this:HTMLAnchorElement, e:JQuery.ClickEvent){
        //     e.preventDefault();
        //     let tr=self.getParentElementByType(this, "tr");
        //     let id=parseInt($(tr).attr("id")!);
        //     // console.log("click edit:"+id);
        //     self.currentRowIndex=id;
        //     formDialog.dialog("open");
        // });
        // $(this.zidx.peakidxShadowRoot).off("click", ".zidxPageActive .zidxScriptDelete").on("click", ".zidxPageActive .zidxScriptDelete", function(this:HTMLAnchorElement, e:JQuery.ClickEvent){
        //     e.preventDefault();
        //     if(!window.confirm("Are you sure you want to delete this row?")){
        //         return;
        //     }
        //     let tr=self.getParentElementByType(this, "tr");
        //     let id=parseInt($(tr).attr("id")!);
        //     $(tr).remove();
        //     self.updateRowIndices();
        //     self.setupSortable();
        //     self.updateData();
        //     // console.log("click delete:"+id, self.landingPage.rows);
        // });
    }
    saveDialog(formDialog:any){
        let self=this;
        // console.log("save form");
        this.lastDialogFormData=this.zidx.getFormDataByFormId((this.formElement!).id);
        let data = this.zidx.getFormDataByFormId((this.formElement!).id);
        let uploading=parseInt(data.fileUploadingField);
        if(uploading>0){
            // console.log("Waiting for the file uploads to finish");
            setTimeout(function(){
                self.saveDialog(formDialog);
            }, 500);
            return;
        }
        this.currentLandingPageRow.saveForm(this, data);
        this.setupSortable();
        this.updateData();
        formDialog.dialog("close");
    }
    setupSortable(){
        let self=this;
        // alert("sortable not implemented because jquery ui is not able to be in module");
        let table=this.zidx.peakidxShadowRoot.querySelector(".zidxAccountLandingPageEditContainer .zidxRecordSort")!;
        this.zidx.setupRecordSort(table, function(result:any){});
        // $("#sortTableID tbody").sortable({
        //     handle: '.sortTableID_handle',
        //     stop: function (e: any, e2: any) {
        //         // console.log("sortable stop fired");
        //         self.updateRowIndices();
        //         self.updateData();
        //     }
        // });
    }
    updateData(){
        this.landingPage.name=(<HTMLInputElement>this.zidx.peakidxShadowRoot.getElementById("landing_page_name")!).value;
        // console.log("updateDebugData", this.landingPage);
        // let a:string[]=[];
        // for(let i=0;i<this.landingPage.rows.length;i++){
        //     a.push(this.landingPage.rows[i].name);
        // }
        // this.debugContainer.innerHTML=a.join("<br>");
        this.debugContainer.innerHTML='Debug Data: Landing Page dump:<br><textarea style="width:100%; height:600px;">'+JSON.stringify(this.landingPage, null, 2).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")+'</textarea>';
        console.log("update json");
        if(this.loadFailed){ return; }
        this.jsonField.value=JSON.stringify(this.landingPage);
    }
    hasFormDataChanged(formObj:HTMLFormElement, cachedData:any):any{
        if(formObj.id == ""){
            return {changed:false};
        }
        let newData=this.zidx.getFormDataByFormId(formObj.id);
        let changed=false;
        for(let i in cachedData){
            if(typeof newData[i]== "undefined"){
                changed=true;
                break;
            }else if(newData[i] != cachedData[i]){
                if(i != "g-recaptcha-response" && i != "form_filling_data" && i != "form_email" && i != "form_session_id"){
                    changed=true;
                    break;
                }
            }
        }
        for(let i in newData){
            if(i != "g-recaptcha-response" && typeof cachedData[i]== "undefined"){
                changed=true;
                break;
            }
        }
        return {changed:changed, data:newData};
    }
    updateRowIndices(){
        peakAlert("sortable not implemented");
        let arrId:string[] = [];// $("#sortTableID tbody").sortable("toArray");
        let rowElements=$("#sortTableID tbody tr");
        let rows = [];
        for (let i = 0; i < arrId.length; i++) {
            let currentId=parseInt(arrId[i]);
            rowElements[i].id=""+i;
            rows.push(this.landingPage.rows[currentId]);
        }
        this.landingPage.rows=rows;
        this.updateData();
        // console.log("New row order", self.landingPage.rows);
    }
    getParentElementByType(obj:any, type:string) {
        let i = 0;
        while (true) {
            i++;
            if (obj.tagName.toLowerCase() == type) {
                return obj;
            }
            if (obj.parentNode != null) {
                obj = obj.parentNode;
            }
            if (i > 50) {
                peakAlert('infinite loop. invalid table html structure');
                return false;
            }
        }
    }
}